import { components } from '@kurtosys/ksys-app-components';

import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent.js';

const Text = components.base.Text.Text;

export default InjectedStyledComponent(Text, 'results', ['text']);
